import React from 'react'

import arrow from '../../images/ARROW.png'
import bloodAndGold from '../../images/Blood & Gold_Production_FINAL_MIDRES_WEB-4096.jpg'
import bloodAndGold2 from '../../images/ARW_2355.jpg'
import bloodAndGold3 from '../../images/ARW_3510.jpg'

function BloodAndBone() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={bloodAndGold}
            className="project-image" />
          <img
            src={bloodAndGold2}
            className="project-image" />
          <img
            src={bloodAndGold3}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Blood and Gold</h1>
          <p className="Project-text">
            <strong>
Short Film
<br />
New Zealand Film Commission
<br />

Director: Yamin Tun
<br />
2018
<br />
<br />

Rehearsal + On Set Acting Coach
<br />
Coached lead actor, Joyena Sun (age 12), nominated Best Actor, Show Me Shorts Film Festival 2021

            </strong>
          </p>
          <p className="Project-testimonial">
            "I've never forgotten the extraordinary work you did. I cannot wait to work with you again.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Yamin Tun, Director</strong>
          </h6>
          <p className="Project-testimonial">
            "I was super happy to see the email on our short film and the nominations the cast and crew got. This is really exciting news and I've been wanting to tell you thank you for helping me so much throughout the filming process. You made this acting experience extremely fun for me.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Joyena Sun, supporting lead</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default BloodAndBone
